import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const updateShadowRecord = async (
  shadowRecordId,
  updates,
  activeEmployerInfo = {}
) => {
  const apiPath = `shadow-data/records/${shadowRecordId}`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: updates,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
